const swiper = new Swiper('.swiper', {
    // Optional Parameters
    direction: 'horizontal',
    spaceBetween: 10,
    slidesPerView: 'auto',
    watchSlidesProgress: true,

    // Keyboard Controls
    keyboard: {
        enabled: true,
    },

    // Navigation Arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        hideOnClick: true,
    },

    // Scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
        // Makes the Scrollbar Draggable
        draggable: true,
        // Snaps slider position to slides when you release Scrollbar
        snapOnRelease: true,
        // Size (Length) of Scrollbar Draggable Element in px
        dragSize: 'auto',
    },
});